import React, {useMemo} from "react"
import { Box, Stack } from "@mui/material"
import {Pie, PieChart} from "recharts";
import Typography from "@mui/material/Typography";
import SquareIcon from '@mui/icons-material/Square';

const statusIndex = {
  APPROVED: 0,
  REVIEW: 1,
  INACTIVE: 2,
  NOT_APPROVED: 3,
  EXPIRED: 4
}
const getDefaultConfig = () => ([
  { name: "Approved", value: 0, fill: "#28be5f" },
  { name: "Review", value: 0, fill: "#b180d1" },
  { name: "Inactive", value: 0, fill: "#6b6666" },
  { name: "Not Approved", value: 0, fill: "#f57d42" },
  { name: "Expired", value: 0, fill: "#e74344" },
])
const noData = [
  { name: "No Data", value: 1, fill: "darkgray" },
]

export default function CertificateCompliancePieChart({ certificates = [] }) {
  const data = useMemo(() => {
    if(certificates?.length) {
      const toReturn = getDefaultConfig()
      certificates.forEach(cert => {
        const categoryIndex = statusIndex[cert.status]
        if(categoryIndex !== undefined) {
          toReturn[categoryIndex].value = toReturn[categoryIndex].value + 1
        }
      })
      return toReturn
    }
    return noData
  }, [certificates])

  return (
    <Box padding={2}>
      <Typography variant="h4" sx={{mb:1}}>
        Certificate Compliance Rate
      </Typography>
      <Typography variant="subtitle1" fontSize={"1.5rem"} color={"gray"}>
        Percentage of compliant insurance documents
      </Typography>
      <PieChart width={300} height={300} style={{marginLeft: "auto", marginRight: "auto"}}>
        <text x={155} y={150} textAnchor="middle" dominantBaseline="middle" style={{fontSize: "45px"}}>
          { certificates?.length
            ? Math.floor((data[0].value/certificates.length) * 100)
            : "0"
          }%
        </text>
        <text x={155} y={180} textAnchor="middle" dominantBaseline="middle" style={{fill: "gray"}}>Compliant</text>
        <Pie
          data={data}
          cx={150}
          cy={150}
          innerRadius={60}
          outerRadius={80}
          dataKey="value"
        />
      </PieChart>
      <Stack>
        {data.map(status => (
          <Stack direction="row">
            <SquareIcon sx={{color: status.fill}}/>
            <Box flexGrow={1} paddingLeft={1}>{status.name}</Box>
          </Stack>
        ))}
      </Stack>
    </Box>
  )
}
